import { secondaryProductsApiConnector } from 'apiConnector/secondary-market/product-search/searchProductsByCode';
import { ofType } from 'redux-observable';
import { EMPTY, of } from 'rxjs';
import { bufferTime, catchError, map, mergeMap } from 'rxjs/operators';
import type { ProductChangeDone } from 'state/secondaryMarket/productSearch';
import {
  secondaryMarketProductsValueChangedDoneThunk,
  secondaryMarketProductsValueChangedFailedThunk,
} from 'state/secondaryMarket/productSearch/productSearch.thunks';
import type { EpicWithThunk } from 'state/state.common';
import type { ApiFunctionalError } from 'utils/http/apiErrorHelper';
import type { HttpError } from 'utils/http/httpClient.model';

export function editProductEpic(): EpicWithThunk {
  return (actions$, _state$, { httpClient, scheduler }) => {
    const { editProducts } = secondaryProductsApiConnector(httpClient);
    return actions$.pipe(
      ofType('SECONDARY_MARKET_PRODUCTS_SALES_MESSAGE_CHANGED_REQUEST'),
      bufferTime(500, scheduler),
      mergeMap(actions => {
        if (actions.length === 0) {
          return EMPTY;
        } else {
          return of(actions);
        }
      }),
      mergeMap(actions => {
        const changes = actions.flatMap(c => c.change);
        return editProducts(changes).pipe(
          map(res => {
            return secondaryMarketProductsValueChangedDoneThunk(
              res.results.flatMap(
                r =>
                  r.fields?.map(
                    f =>
                      ({
                        field: f.field!,
                        hasBeenUpdated: f.hasBeenUpdated!,
                        rowId: r.rowId,
                      }) as ProductChangeDone,
                  ) ?? [],
              ),
              res.errors,
              res.warnings,
            );
          }),
          catchError((e: HttpError<ApiFunctionalError>) => {
            return of(
              secondaryMarketProductsValueChangedFailedThunk(
                changes.map(c => ({ field: c.field, rowId: c.rowId })),
                e.payload?.message,
              ),
            );
          }),
        );
      }),
    );
  };
}
